import { AssessmentQuestionType } from "types/graphql-schema";

import { TopicflowIconMap } from "@components/topicflow-icon/topicflow-icon-helpers";

export const assessmentQuestionIcon = {
  [AssessmentQuestionType.Range]: TopicflowIconMap.range,
  [AssessmentQuestionType.Text]: TopicflowIconMap.text,
  [AssessmentQuestionType.Multichoice]: TopicflowIconMap.multichoice,
  [AssessmentQuestionType.Nps]: TopicflowIconMap.nps,
};
